// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  authenticationOptions: {
    tenant: "c16e514b-893e-4a01-9a30-b8fef514a650 ",
    clientId: "c974ee85-d721-4358-b492-22959af1dbe8",
    endpoints: {
      "https://dev-dte-aks.eni.com": "c974ee85-d721-4358-b492-22959af1dbe8",
      "https://prod-dte-aks.eni.com": "c974ee85-d721-4358-b492-22959af1dbe8",
    },
    // https://github.com/AzureAD/azure-activedirectory-library-for-js/blob/dev/lib/adal.js#L35
    redirectUri: document.location.origin,
    navigateToLoginRequestUrl: false,
    cacheLocation: "localStorage"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
